import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import LoginPage from "./components/LoginPage";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AnnotationDemo from "./components/AnnotationDemo";
import AutoAnnotationDemo from "./components/AutoAnnotationDemo";
import { supabase } from "./supabaseClient";
import PaymentSuccess from "./components/PaymentSuccess";
import { Analytics } from "@vercel/analytics/react";
import IntegrationsSection from "./components/IntegrationsSection";
import IntegrationsPage from "./components/IntegrationsPage";
import useFeatures from "./hooks/useFeatures";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { hasIntegrationsFeature } = useFeatures();

  useEffect(() => {
    // Check if we already have a valid JWT
    const existingToken = localStorage.getItem("authToken");
    if (existingToken) {
      setIsAuthenticated(true);
      return;
    }

    // Only check Supabase session if we don't have a JWT
    async function checkSession() {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();

      console.log("Supabase session:", session, error);

      if (session && session.access_token) {
        try {
          const response = await axios.post("/auth/supabase", {
            token: session.access_token,
          });
          const { access_token } = response.data;
          if (access_token) {
            localStorage.setItem("authToken", access_token);
            localStorage.setItem("username", response.data.user.username);
            console.log("JWT stored in localStorage");
            setIsAuthenticated(true);
          }
        } catch (err) {
          console.error("Error exchanging token with backend:", err);
        }
      }
    }

    checkSession();

    // Optionally, you can listen for auth state changes:
    // const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
    //   console.log("Auth state changed:", event, session);
    //   // You can run similar logic as in checkSession()
    // });

    // Cleanup if using authListener:
    // return () => authListener.subscription.unsubscribe();
  }, []);

  return (
    <Router>
      <Analytics />

      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage />
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/annotation"
          element={
            <ProtectedRoute>
              <AnnotationDemo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auto-annotation"
          element={
            <ProtectedRoute>
              <AutoAnnotationDemo />
            </ProtectedRoute>
          }
        />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route
          path="/integrations"
          element={
            <ProtectedRoute>
              {hasIntegrationsFeature() ? <IntegrationsPage /> : <Navigate to="/dashboard" replace />} 
              {/*<IntegrationsPage /> */}
            </ProtectedRoute>
          }
        />
        {/* Keeping existing section route if used elsewhere */}
        <Route path="/IntegrationSection" element={<IntegrationsSection />} />
      </Routes>
    </Router>
  );
}

export default App;

















































































































































































































































































































